import { Box, ButtonAppearance, ModalBackdropStyled, SideSheetClose, SideSheetHeader } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: fixed;
  left: 0;
  top: 40px;
  height: calc(100vh- 40px);
  z-index: 2;
`;
export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.grey[200]};
  display: flex;
  flex-direction: column;
  height: 100%;
  top: 0;
  right: 0;
  overflow: hidden;
  position: absolute;
  width: 300px;
`;
export const DrawerHeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.primary[700]};
      color: ${theme.colors.white};
      padding: ${theme.spacings[600]} ${theme.spacings[500]};
    `}
`;

export const DrawerCloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.white};
      border: none;
      margin-top: ${theme.spacings[200]};
    `}
`;

export const ProjectTileStyled = styled(Box).attrs({
  px: { sm: '450' },
  py: { sm: '250' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) =>
    css`
      border: solid 0.5px ${theme.colors.grey[200]};
      overflow: hidden;
      cursor: pointer;
      height: ${theme.componentStyles.pageHeaderHeight};
      &:hover {
        background-color: ${theme.colors.blue[100]};
      }
    `}
`;

export const ProjectImageStyled = styled(Box).attrs({ mr: { sm: '300' } })`
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  img {
    width: 100%;
  }
`;

export const SubContainerStyled = styled(Box).attrs({ pl: { sm: '450' }, alignItems: { sm: 'center' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    height: ${theme.spacings[600]};
  `}
`;
